import { useCallback, useEffect, useRef, useState } from 'react';
import { getUnreadCount } from '../api/supportApi';

const POLL_INTERVAL_MS = 60000;

/**
 * @param {string} token
 * @returns {{ count: number, isLoading: boolean, reload: Function }}
 */
export const useSupportUnreadCount = (token) => {
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const cancelledRef = useRef(false);

  const loadCount = useCallback(async () => {
    if (!token) return;
    setIsLoading(true);
    try {
      const payload = await getUnreadCount(token);
      if (cancelledRef.current) return;
      setCount(payload?.count ?? 0);
    } catch {
      // Silent — background polling; errors surface on the next tick.
    } finally {
      if (!cancelledRef.current) {
        setIsLoading(false);
      }
    }
  }, [token]);

  useEffect(() => {
    cancelledRef.current = false;
    loadCount();
    const handle = setInterval(loadCount, POLL_INTERVAL_MS);
    return () => {
      cancelledRef.current = true;
      clearInterval(handle);
    };
  }, [loadCount]);

  return { count, isLoading, reload: loadCount };
};
